import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from "./UserAppResource";
import Engine from "@milestoneslabs/milestones-js-engine/src/Engine";
import axios from "axios";

class ServiceProviderImportAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-import';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/imports';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'file',
            'importType',
            'userUuid',
            'errorLog'
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            user: UserAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            user: 'user_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            file: {
                type: 'object',
            },
            userUuid: {
                type: 'string',
            },
            importType: {
                type: 'string',
                presence: true,
            },
            errorLog: {
                type: 'string'
            }
        };
    }

    apiPaths() {
        return {
            'download': Engine.apiUrl(this.appResourceApiPrefix()) + '/{uuid}/download',
            'download-error-log': Engine.apiUrl(this.appResourceApiPrefix()) + '/{uuid}/download/error-log',
            ...super.apiPaths(),
        }
    }

    async download() {
        const url = this.apiPaths().download.replace('{uuid}', this.uuid);
        return await axios.post(url);
    }

    async downloadErrorLog() {
        const url = this.apiPaths()['download-error-log'].replace('{uuid}', this.uuid);
        const response = await axios.post(url, {}, {responseType: 'blob'});
        this.startDownload(response.data, this.errorLog.replace(/^.*[\\\/]/, ''));
    }

    startDownload(data, fileName) {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([data]));
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

export default ServiceProviderImportAppResource;
